/** Quality markers — `:Badge` nodes on the server. The client renders each by
 *  its fixed `type`. Interest groups are NOT listed here: their `type` is the
 *  group's own string, and the client never compares it (ADR-0085). */
export enum BadgeType {
  VERIFIED = 'verified',
}

/**
 * Discriminates the two kinds of entry in a payload's `badges` list
 * (ADR-0085). A quality marker is rendered by its `type`; an interest-group
 * badge is rendered as the shield glyph plus its `title`, and its `type` (the
 * group's own type string) is never compared to anything on the client.
 */
export enum BadgeKind {
  QUALITY = 'quality',
  INTEREST_GROUP = 'interest_group',
}

export interface Badge {
  id: string
  title: string
  icon: string
  /** A quality marker's fixed `BadgeType`, or an interest group's type string. */
  type: string
  priority?: number
  /** Always set by the current server; absent on documents written before it. */
  kind?: BadgeKind
}

/**
 * The interest-group entries of a payload's `badges` list, in wire order.
 * Picks by `kind` only — never by `type`. An entry with no `kind` predates the
 * discriminator and can only be a quality marker, so it is not picked.
 */
export function interestGroupBadgesOf(badges: readonly Badge[] | null | undefined): Badge[] {
  return (badges ?? []).filter((badge) => badge.kind === BadgeKind.INTEREST_GROUP)
}
